<template>
  <div>
    <Layout>
      <template v-slot:default>
        <div class="bg-white rounded-lg shadow-md p-6 mt-32">
          <div class="items-center justify-center text-center">
            <h2 class="text-6xl font-semibold text-main-text mb-5">Government Authorized Course</h2>
            <hr class="w-20 h-1 mx-auto my-4 -mt-3 bg-main-orange border-0 rounded md:my-6 dark:bg-gray-700" />
          </div>
          <div class="
                                        flex
                                        items-center
                                        justify-center
                                        text-center
                                        mb-8 
                                        rounded-lg
                                    ">
            <img class="w-full  rounded-lg shadow-md max-w-4xl"
              src="https://images.pexels.com/photos/7055670/pexels-photo-7055670.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Dr. Manisha's Yoga Institute">
          </div>
          <div class="max-w-3xl mx-auto my-8">
            <h1 class="text-3xl font-bold mb-4">60-hour Prenatal and Postnatal Yoga and Garbha Sanskara Teacher Training
              Program</h1>
            <h2 class="text-xl font-bold mb-2">Become a Certified Prenatal and Postnatal Yoga Instructor and Help Mothers
              with Dr. Manisha's Yoga Institute</h2>
            <div class="mb-4 flex items-center">
              <div class="mr-2 flex items-center">
                <i class="fas fa-star text-yellow-300"></i>
                <i class="fas fa-star text-yellow-300"></i>
                <i class="fas fa-star text-yellow-300"></i>
                <i class="fas fa-star text-yellow-300"></i>
                <i class="fas fa-star text-gray-300"></i>
              </div>
              <span class="text-gray-600 text-sm">(3,360)</span>
            </div>
            <div class="my-8">
              <h3 class="text-lg font-bold mb-4">Program Details</h3>
              <ul class="list-disc pl-4">
                <li>Learn the Importance of Yoga in Prenatal and Postnatal</li>
                <li>Understand Fetal Development (Anatomy and Physiology)</li>
                <li>Discover Trimester-wise Development (Changes Physically and Mentally)</li>
                <li>Explore Stages of Labor</li>
                <li>Study Asana before Conception</li>
                <li>Practice Prenatal Asanas</li>
                <li>Master Postnatal Asanas</li>
                <li>Learn Meditation</li>
                <li>Discover Mudras</li>
                <li>Study Samskaras</li>
                <li>Understand the Importance of Sankalpa</li>
                <li>Experience Yoga Nidra</li>
                <li>Explore the Importance of Cleansing Techniques in Prenatal and Postnatal</li>
                <li>Study the Importance of Pelvic Floor and Bandhas in Prenatal and Postnatal</li>
                <li>Discover Ayurveda and Pregnancy</li>
                <li>Learn about Nutrition Sessions</li>
                <li>Participate in Pre-natal and Post-natal Case Sheet Discussions</li>
                <li>Undergo Student Assessment</li>
                <li>Participate in Live Classes and Live Group Discussions (Q&amp;A)</li>
                <li>Receive Course Manual and Notes</li>
              </ul>
            </div>

            <div class="my-8">
              <h3 class="text-lg font-bold mb-4">Class Schedule</h3>
              <p class="mb-2">Every Sunday from 7:30 am to 9:00 am</p>
            </div>

            <div class="mb-4">
              <p class="text-gray-700 dark:text-gray-400 mb-2">
                <strong>Contact Details:</strong>
              </p>
              <p class="text-gray-700 dark:text-gray-400 mb-1">
                Phone: <a class="text-main-orange" href="tel:8308315494">830 831 5494</a> / <a class="text-main-orange"
                  href="tel:9422017342">942 2017 342</a>
              </p>
              <p class="text-gray-700 dark:text-gray-400 mb-1">
                Email: <a class="text-main-orange" href="mailto:drmanishas777@gmail.com">drmanishas777@gmail.com</a>
              </p>

            </div>

            <div class="my-8">
              <h3 class="text-lg font-bold mb-4">Enrollment</h3>
              <p class="mb-2">Hurry up and join the upcoming batch to become a certified Prenatal and Postnatal Yoga
                Instructor and help mothers.</p>
            </div>
          </div>
          <div
            class="bg-main-bg bg-opacity-20 backdrop-filter backdrop-blur-lg backdrop-saturate-150 rounded-lg shadow-md p-6 mt-8 max-w-md mx-auto">
            <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Enroll Now - <em>Pregnancy Yoga
                Certification Course</em></h2>
            <form @submit.prevent="submitForm" method="POST">
              <div class="mb-4">
                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="full_name">
                  Full Name<span class="text-red-500">*</span>
                </label>
                <input v-model="fullName"
                  class="form-input rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                  id="full_name" name="full_name" type="text" placeholder="Enter your full name">
                <p v-if="formErrors.fullName" class="text-red-500">{{ formErrors.fullName }}</p>
              </div>
              <div class="mb-4">
                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="email">
                  Email Address<span class="text-red-500">*</span>
                </label>
                <input v-model="email"
                  class="form-input rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                  id="email" name="email" type="email" placeholder="Enter your email address">
                <p v-if="formErrors.email" class="text-red-500">{{ formErrors.email }}</p>
              </div>
              <div class="mb-4">
                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="phone">
                  Phone Number<span class="text-red-500">*</span>
                </label>
                <input v-model="phone"
                  class="form-input rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                  id="phone" name="phone" type="tel" placeholder="Enter your phone number">
                <p v-if="formErrors.phone" class="text-red-500">{{ formErrors.phone }}</p>
              </div>
              <div class="mb-4">
                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="message">
                  Message (optional)
                </label>
                <textarea v-model="message"
                  class="form-textarea rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                  id="message" name="message" placeholder="Enter your message"></textarea>
              </div>
              <button
                class="bg-main-orange hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded w-full transition-colors duration-300 ease-in-out"
                type="submit">Enroll Now</button>
            </form>
          </div>
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
// import YogaInstructor from '../components/Courses/YogaInstructor/YogaInstructor.vue';
import Layout from '../Layout/Layout.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import { API_URL } from '@/config';
import emailjs from 'emailjs-com';


export default {
  name: "YogaInstructor",
  components: { Layout },
  metaInfo() {
    return {
      title: 'Pregnancy Yoga Certification Course | Dr. Manishas Yoga Institute',
      meta: [
        { name: 'description', content: 'Prenatal and Postnatal Yoga Instructor Certification Course is a 200-hour course that will help you become a certified yoga instructor and help mothers.' },
        { name: 'keywords', content: 'prenatal yoga instructor certification course, postnatal yoga instructor certification course, prenatal yoga instructor course, postnatal yoga instructor course, prenatal yoga instructor training, postnatal yoga instructor training, prenatal yoga instructor course near me, postnatal yoga instructor course near me, prenatal yoga instructor course online, postnatal yoga instructor course online, prenatal yoga instructor course fees, postnatal yoga instructor course fees, prenatal yoga instructor course syllabus, postnatal yoga instructor course syllabus, prenatal yoga instructor course duration, postnatal yoga instructor course duration, prenatal yoga instructor course in india, postnatal yoga instructor course in india, prenatal yoga instructor course in mumbai, postnatal yoga instructor course in mumbai, prenatal yoga instructor course in pune, postnatal yoga instructor course in pune, prenatal yoga instructor course in bangalore, postnatal yoga instructor course in bangalore, prenatal yoga instructor course in delhi, postnatal yoga instructor course in delhi, prenatal yoga instructor course in hyderabad, postnatal yoga instructor course in hyderabad, prenatal yoga instructor course in chennai, postnatal yoga instructor course in chennai, prenatal yoga instructor course in kolkata, postnatal yoga instructor course in kolkata, prenatal yoga instructor course in ahmedabad, postnatal yoga instructor course in ahmedabad, prenatal yoga instructor course in jaipur, postnatal yoga instructor course in jaipur, prenatal yoga instructor course in surat, postnatal yoga instructor course in surat, prenatal yoga instructor course in kanpur, postnatal yoga instructor course in kanpur, prenatal yoga instructor course in nagpur, postnatal yoga instructor course in nagpur, prenatal yoga instructor course in lucknow, postnatal yoga instructor course in lucknow, prenatal yoga instructor course in pune, postnatal yoga instructor course in pune, prenatal yoga instructor course in indore, postnatal yoga instructor course in indore, prenatal yoga instructor course in thane, postnatal yoga instructor course in thane, prenatal yoga instructor course in bhopal, postnatal yoga instructor course in bhopal, prenatal yoga instructor course in visakhapatnam, postnatal yoga instructor course in visakhapatnam, prenatal yoga instructor course in patna, postnatal' }
      ]
    }
  },
  data() {
    return {
      fullName: '',
      email: '',
      phone: '',
      message: '',
      formErrors: {},
    };
  },
  methods: {
    validateForm() {
      let isValid = true;
      this.formErrors = {};

      if (!this.fullName) {
        this.formErrors.fullName = 'Please enter your full name';
        isValid = false;
      }

      if (!this.email) {
        this.formErrors.email = 'Please enter your email address';
        isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.formErrors.email = 'Please enter a valid email address';
        isValid = false;
      }

      if (!this.phone) {
        this.formErrors.phone = 'Please enter your phone number';
        isValid = false;
      } else if (!/^\d{10}$/.test(this.phone)) {
        this.formErrors.phone = 'Please enter a valid phone number';
        isValid = false;
      }

      return isValid;
    },

    async submitForm() {
      try {
        if (this.validateForm()) {
          // Make API call to submit form data
          await axios.post('https://formspree.io/f/xeqbjjpa', {
            fullName: this.fullName,
            email: this.email,
            phone: this.phone,
            message: this.message
          });

          // Save form data to MongoDB
          await axios.post(`${API_URL}/api/pregnancyform`, {
            fullName: this.fullName,
            email: this.email,
            phone: this.phone,
            message: this.message
          });

          // add a loading untill we see show success message
          await Swal.fire({
            title: 'Please wait...',
            html: 'We are submitting your form',
            onBeforeOpen: () => {
              Swal.showLoading();
            },
            showConfirmButton: false,
            showCancelButton: false,
            showDenyButton: false,
            type: 'success',
            timer: 2000

          });

          // Send email to user
          const emailParams = {
            fullName: this.fullName,
            to_email: this.email,
            from_email: 'drmanishas777@gmail.com',
            // from_name: "Dr. Manisha's Yoga Institute",

          }
          const emailResponse = await emailjs.send(
            'service_91st2jd',
            'template_sp8ex9q',
            emailParams,
            'toWDk4koE8-1VmUIV'
          )
          console.log(emailResponse);


          // Show success message
          await Swal.fire({
            icon: 'success',
            title: 'Pregnancy Yoga Certification Course',
            text: `Thank you ${this.fullName} for enrolling! We will get back to you soon with full details`
          });
          // Clear form
          this.fullName = '';
          this.email = '';
          this.phone = '';
          this.message = '';

        }
      } catch (error) {
        // Show error message
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong. Please try again later.'
        });
      }
    }
  }


}
</script>